import React from 'react';
import { FaHome } from 'react-icons/fa';

const AddressShippingForm = ({ formData, handleInputChange }) => {
  return (
    <div className="mt-3 grid grid-cols-2 gap-4">
      {/* Адрес заема две колони */}
      <div className="col-span-2">
        <label htmlFor="address" className="block mb-1 font-medium flex items-center">
          <FaHome className="mr-2 text-gray-600" size={16} />
          Адрес *</label>
        <input
          type="text"
          id="address"
          name="address"
          value={formData.address}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          required
          placeholder="Улица, номер, блок, вход, етаж, апартамент"
        />
      </div>

      {/* Град */}
      <div>
      <label htmlFor="city" className="block mb-1 font-medium">
        Населено място *
      </label>
        <input
          type="text"
          id="city"
          name="city"
          value={formData.city}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          required
          placeholder="Пример: София, Пловдив, Варна..."
        />
      </div>

      {/* Пощенски код */}
      <div>
        <label htmlFor="postcode" className="block mb-1 font-medium">
          Пощенски код *
        </label>
        <input
          type="text"
          id="postcode"
          name="postcode"
          value={formData.postcode}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          required
          placeholder="Пример: 1000"
        />
      </div>
    </div>
  );
};

export default AddressShippingForm; 